import React from 'react';
import { Spinner } from 'reactstrap';
import { useSelector } from 'react-redux';
import { getThemeColor } from 'store/settings';

const Loading = () => {
  const themeStatus = useSelector(getThemeColor);
  return (
    <div
      className="full-height full-width"
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Spinner
        style={{ width: '3rem', height: '3rem', color: `${themeStatus}` }}
      />
    </div>
  );
};

export default Loading;
